export function isHomeMenuDataReady({ finishedValidations, isLoadingFeatureFlags, isLoadingBillingManagementActive, isLoadingNFSeAccess, hasClientPortalViewPermission, hasSelectedAccount, }) {
    return (finishedValidations &&
        !isLoadingFeatureFlags &&
        !isLoadingBillingManagementActive &&
        !isLoadingNFSeAccess &&
        hasClientPortalViewPermission !== undefined &&
        hasSelectedAccount);
}
export function getSingleFunctionalMenuItemPath(menuItems) {
    const functionalMenuItems = menuItems.filter(item => item.path !== '/suporte');
    return functionalMenuItems.length === 1 ? (functionalMenuItems[0].path ?? null) : null;
}
export function shouldRedirectFromHome({ areHomePermissionsReady, isHomeProductsLoading, pathname, singleMenuItemPath, }) {
    return areHomePermissionsReady && !isHomeProductsLoading && pathname === '/home' && !!singleMenuItemPath;
}
